export const CONNECT_EMR_PATH = "/home-health/connect-emr";
